<template>
  <div class="card">
    <div class="img">
      <img :src="contentUrl + articleOfDay.image" alt="">
    </div>

    <div class="card__content">
      <h3>{{articleOfDay.title}}</h3>
      <p>{{articleOfDay.readTime}}</p>

      <div class="card__action" @click="$router.push('/profile/articles#article' + articleId)">
        {{ $t("profile.home.readArticle") }}
      </div>
    </div>
  </div>
</template>

<script>
import articlesList from "./data/articles.en.json";

export default {
  name: "day-article",

  inject: ['contentUrl'],

  props: ["date"],

  data() {
    return {
      articleOfDay: {},
      currentDate: new Date(this.date),
      articles: articlesList,
    };
  },

  async created() {
    try {
      const localeData = await import(`./data/articles.${this.$i18n.locale}.json`);
      this.articles = localeData.default;
    } catch (e) {
      console.log(e);
    }

    this.articleOfDay = this.getArticleOfDay();
  },

  computed: {
    articleId() {
      return Object.values(this.articles).indexOf(this.articleOfDay.title);
    },
  },

  watch: {
    date(value) {
      this.currentDate = new Date(value);
      this.articleOfDay = this.getArticleOfDay();
    },
  },

  methods: {
    getArticleOfDay() {
      const day = this.currentDate.getDate();
      const articles = Object.keys(this.articles);

      if (day > articles.length - 1) {
        return this.articles[articles[day % articles.length]];
      } else {
        return this.articles[articles[day]];
      }
    },
  },
}
</script>

